import { TransactionState } from '@softline/core';

export interface UploadProgress {
  file: File;
  state: TransactionState;
  uploaded: number;
  total: number | null;
}
